import React, {Component} from 'react';
import {Col, Form, FormGroup, ControlLabel} from "react-bootstrap";
import {TopInputDate} from "../../../../componentsTopsa/inputs/TopInputs";
import moment from 'moment'
import TrasyService from "../../../konfiguracja/trasyConfig/trasy/TrasyService";
import TopDostepnosc from "../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import {TopSelect} from "../../../../componentsTopsa/selects/TopSelects";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";

export default class OcenySearchbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataOd:moment(),
            dataDo:moment(),
            trasa: null,
            trasy:[],
        };
        this.onChangeDataOd = this.onChangeDataOd.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }

    componentDidMount(){

        let now = moment();
        let obecny_rok = (now.year());
        let obecny_miesiac = (now.month()) + 1;

        let pierwszy_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-01')

        let ostatni_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-' + moment(now).daysInMonth())

        this.setState({
            dataOd: pierwszy_miesiaca,
            dataDo:ostatni_miesiaca
        })

        this.pobierzTrasy()
    }

    pobierzTrasy(){
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy:response.data.content})
        }.bind(this))
    }

    onChangeDataOd(e){
        this.setState({dataOd:e})
    }
    onChangeDataDo(e){
        this.setState({dataDo:e})
    }
    onChangeTrasa(e){
        this.setState({trasa:e})
    }

    onClickSzukaj(){
        if(Boolean(this.state.dataOd) && Boolean(this.state.dataDo)){
            if(DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd)<=DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo)){
                this.props.handleClickSzukaj(DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd),DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo),Boolean(this.state.trasa)? this.state.trasa.idTr:null)
            }
        }
    }


    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc wartoscWarunek={0}
                                                                                                                          wartosc={option.status}
                                                                                                                          czyMarginesLewy={true}/>
        </div>
    }

    render() {

        return (
           <div>
               <Form horizontal={true}>
                   <FormGroup>
                       <Col xs={2}>
                           <ControlLabel>Od daty <span className={'req'}>*</span></ControlLabel>
                           <TopInputDate onChange={this.onChangeDataOd} value={this.state.dataOd} horizontal={true}/>
                       </Col>
                       <Col xs={2}>
                           <ControlLabel>Do daty <span className={'req'}>*</span></ControlLabel>
                           <TopInputDate onChange={this.onChangeDataDo} value={this.state.dataDo} horizontal={true}/>
                       </Col>
                       <Col xs={3}>
                           <ControlLabel>Trasa</ControlLabel>
                           <TopSelect onChange={this.onChangeTrasa} value={this.state.trasa} options={this.state.trasy} labelKey={'nazTr'}
                                      valueKey={'idTr'} valueRenderer={this.formatTrasaSelect} optionRenderer={this.formatTrasaSelect}/>
                       </Col>
                       <Col xs={2}>
                           <div className={'add-label-margin'}></div>
                           <TopButtonAction iconType={'fa fa-search'} btnSize={'md'} btnColor={'primary'} text={'Wyświetl oceny'} onClick={this.onClickSzukaj}/>
                       </Col>
                   </FormGroup>
               </Form>
           </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/oceny/components/OcenySearchbox.js